module.exports = __webpack_public_path__ + "img/banner1.503d08c3.png";